import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { alignItems, colors, strCode } from "../../../../../../../consts";
import { t } from "../../../../../../../services";
import { useDebounce } from "../../../../../../../hooks";

import {
  FlexContainers,
  IconButton,
  SVG,
  TextArea,
  WrapperContainer
} from "../../../../../../../components";
import { AddSummaryButton, SummaryTitleContainer, Title } from "./styled";

export const SummaryOfChanges = ({ summaryOfChanges, onChangeSummary, hasError, showErrors }) => {
  const [summary, setSummary] = useState(null);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    setSummary(summaryOfChanges ?? null);
  }, [summaryOfChanges]);

  const toggleSummary = () => {
    const newSummary = summary == null ? "" : null;
    setSummary(newSummary);

    if (newSummary != null) {
      setIsVisible(true);
    }
  };

  const toggleVisibility = () => {
    setIsVisible((prev) => !prev);
  };

  const saveSummary = () => {
    onChangeSummary(summary);
  };

  useDebounce(saveSummary, 100, summary);

  return (
    <WrapperContainer width={"100%"} p={16} pb={0}>
      {summary != null ? (
        <WrapperContainer
          Container={FlexContainers.FlexRowBetween}
          alignItems={alignItems.center}
          mt={7}
          gap={16}
          width={"100%"}>
          <SummaryTitleContainer
            Container={FlexContainers.FlexRow}
            alignItems={alignItems.center}
            gap={8}>
            <SVG.SummaryIcon color={showErrors && hasError ? colors.ERROR : colors.RAISIN_100} />
            <Title hasError={showErrors && hasError}>{t(strCode.SUMMARY_OF_CHANGES_TITLE)}</Title>
          </SummaryTitleContainer>

          <WrapperContainer
            Container={FlexContainers.FlexRow}
            alignItems={alignItems.center}
            gap={24}
            pr={16}>
            <IconButton onClick={toggleSummary}>
              <SVG.DeleteIcon />
            </IconButton>

            <IconButton onClick={toggleVisibility}>
              <SVG.DownArrowIcon color={colors.RAISIN_100} flipVert={!isVisible} />
            </IconButton>
          </WrapperContainer>
        </WrapperContainer>
      ) : (
        <AddSummaryButton onClick={toggleSummary}>
          <SVG.SummaryIcon />
          <Title>{t(strCode.ADD_SUMMARY_BTN)}</Title>
        </AddSummaryButton>
      )}

      {summary != null && isVisible && (
        <WrapperContainer Container={FlexContainers.FlexColumn} mt={8} width={"100%"}>
          <TextArea
            id={"summary"}
            value={summary}
            setValue={setSummary}
            placeholder={t(strCode.SUMMARY_OF_CHANGES_TITLE)}
            hasError={showErrors && hasError}
          />
        </WrapperContainer>
      )}
    </WrapperContainer>
  );
};

SummaryOfChanges.propTypes = {
  summaryOfChanges: PropTypes.string,
  hasError: PropTypes.bool.isRequired,
  showErrors: PropTypes.bool.isRequired,
  onChangeSummary: PropTypes.func.isRequired
};
